import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  CANCEL_PAUSE_REQUEST_MODAL_STAGES,
  cancelRequestModalStageSelector,
  setCancelRequestModalStage,
} from 'features/courseResume';
import CancelRequestModalStageRenderer from '../CancelRequestModalStageRenderer';

function CancelRequestModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(cancelRequestModalStageSelector);
  const isModalOpen = modalStage !== CANCEL_PAUSE_REQUEST_MODAL_STAGES.notOpen;

  const handleClose = useCallback(() => {
    dispatch(
      setCancelRequestModalStage(CANCEL_PAUSE_REQUEST_MODAL_STAGES.notOpen)
    );
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleClose}
      withoutHeader
      hasCloseButton={false}
    >
      <CancelRequestModalStageRenderer />
    </Modal>
  );
}

export default CancelRequestModal;
